<script setup>
const props = defineProps({
    sponsors: {
        type: Object,
        required: true,
    },
});
const keys = Object.keys(props.sponsors);
</script>

<template>
    <div class="sponsors-list-wrapper">
        <FragmentsSponsorsListItem v-for="level in keys" :key="level" :level="level" :sponsors="sponsors[level]" />
    </div>
</template>
